import http from '../config/http';
import routes from '../config/api_routes';

export const getActivePrivacyPolicy = () => http().get(routes.PrivacyPolicy.getActive)
